import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './form.magic.css.js';
import script from './form.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",attrs:{"part":"form"}},[_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h2","part":"title","data-v-test-id":"account-closure-form-title","content":_vm.$t('account-closure-form.title')}}),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-button',{attrs:{"wide":"","variant":"error","data-v-test-id":"account-closure-submit-button"},domProps:{"innerHTML":_vm._s(_vm.$t('account-closure-form.button'))},on:{"click":_vm.closeAccount}}),_vm._v(" "),_c('magic-ui-link',{attrs:{"button":"","wide":"","hollow":"","to":_vm.RoutablePage.HOME,"data-v-test-id":"account-closure-cancel-button"},domProps:{"innerHTML":_vm._s(_vm.$t('account-closure-form.cancel'))}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2ecf0858_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-2ecf0858";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
